export enum MatchResultEnum {
    None = 0,
    Victory = 1,
    Defeat = 2,
    Draw = 3
}